import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getCards = () => {
    return request({
        url: namespace + "/events",
        method: "get",
    });
};

export const getEvent = (_id, _status) => {
    return request({
        url: namespace + "/event/" + _id + "/" + _status,
        method: "get",
    });
};
